

  <div class="login-box" >
    <div class="login-logo">
      <app-logo [hide]='"mini"'></app-logo>

    </div>
    <!-- /.login-logo -->
    <div class="card">
      <div class="card-body login-card-body">
        <h3 class="recovery-title">{{ translate.instant('PAGES.passwordRecovery') }}</h3>

        <div *ngIf="ktidentityMode && ktidentityReason" class="alert alert-warning" role="status">
          {{ translate.instant(ktidentityReason === 'locked' ? 'PAGES.ktidentityRecovery.reasonLocked' : 'PAGES.ktidentityRecovery.reasonExpired') }}
        </div>

        <div *ngIf="ktidentitySent" class="alert alert-success" role="status">
          {{ translate.instant('PAGES.ktidentityRecovery.sent') }}
        </div>

        <ng-container *ngIf="!isValid && !ktidentitySent">
          <p class="login-box-msg">{{ translate.instant('PAGES.enterYourEmailToRecoverPassword') }}</p>

          <form #formForgot="ngForm">

            <div class="form-group has-feedback">
              <label for="eml" class="visually-hidden">{{ translate.instant('LOGIN.email') }}</label>
              <input type="email" class="form-control" placeholder="Email" required autocomplete="email" id="eml" name="eml" [(ngModel)]="user!.email" #eml="ngModel">
              <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
              <div *ngIf="eml.errors && (eml.dirty || eml.touched)" class="alert alert-danger" role="alert">
                  <div [hidden]="!eml.errors['required']">
                    {{ translate.instant('PAGES.emailIsRequired') }}
                  </div>
              </div>
            </div>

            <div class="row">
              <!-- /.col -->
              <div class="col-4">
                <button type="submit" [disabled]="!formForgot.valid" class="btn btn-primary btn-block btn-flat" (click)="submitRecovery()">{{ translate.instant('PAGES.send') }}</button>
              </div>
              <!-- /.col -->
            </div>

          </form>
        </ng-container>

        <ng-container *ngIf="isValid">
          <p class="login-box-msg">{{ translate.instant('PAGES.enterYourVerificationCodeAndNewPassword') }}</p>

          <form #formConfirm="ngForm">

            <div class="form-group has-feedback">
              <label for="code" class="visually-hidden">{{ translate.instant('PAGES.verificationCodePlaceholder') }}</label>
              <input type="text" class="form-control" [placeholder]="translate.instant('PAGES.verificationCodePlaceholder')"
                autocomplete="one-time-code" required id="code" name="code" [(ngModel)]="user!.code" #code="ngModel">
              <span class="glyphicon glyphicon-asterisk form-control-feedback"></span>
              <div *ngIf="code.errors && (code.dirty || code.touched)" class="alert alert-danger" role="alert">
                  <div [hidden]="!code.errors['required']">
                    {{ translate.instant('PAGES.verificationCodeIsRequired') }}
                  </div>
              </div>
            </div>

            <div class="form-group">
              <label for="passwd" class="visually-hidden">{{ translate.instant('PAGES.newPasswordPlaceholder') }}</label>
              <app-password-input id="passwd" name="passwd" [placeholder]="translate.instant('PAGES.newPasswordPlaceholder')"
                autocomplete="new-password" required minlength="8" [(ngModel)]="user!.password"
                (ngModelChange)="onPasswordChange($event)" #passwd="ngModel"></app-password-input>
              <div *ngIf="passwd.errors && (passwd.dirty || passwd.touched)"
                  class="alert alert-danger" role="alert">
                  <div [hidden]="!passwd.errors['required']">
                    {{ translate.instant('PAGES.passwordIsRequired') }}
                  </div>
                  <div [hidden]="!passwd.errors['minlength']">
                    {{ translate.instant('PAGES.passwordMustBeAtLeast8Characters') }}
                  </div>
              </div>
              <app-password-strength-checklist [flags]="passwordFlags"></app-password-strength-checklist>
            </div>

            <div class="row">
              <!-- /.col -->
              <div class="col-4">
                <button type="submit" [disabled]="!formConfirm.valid" class="btn btn-primary btn-block btn-flat" (click)="changePassword()">{{ translate.instant('PAGES.send') }}</button>
              </div>
              <!-- /.col -->
            </div>

          </form>
        </ng-container>
      </div>
    </div>
  </div>
